export const notificationFrontendPath = '/notification';
export const notificationBackendPath = '/backend/notification/';

export const notificationCreateFrontendPath = '/notification/create';
export const notificationCreateBackendPath = '/backend/notification/create/';

export const notificationEditFrontendPath = '/notification/:id';
export const notificationEditBackendPath = '/backend/notification/edit/';

export const notificationDetailFrontendPath = '/notification/:id/detail';
export const notificationDetailBackendPath = '/backend/notification/detail/';

export const smsCreateFrontendPath = '/notification/sms/create';
export const smsCreateBackendPath = '/backend/notification/sms/send/';

export const popupNotificationFrontendPath = '/popup_notification';
export const popupNotificationBackendPath = '/backend/notification/popup_notification/';

export const popupNotificationCreateFrontendPath = '/popup_notification/create';
export const popupNotificationCreateBackendPath = '/backend/notification/popup_notification/create/';

export const popupNotificationEditFrontendPath = '/popup_notification/:id';
export const popupNotificationEditBackendPath = '/backend/notification/popup_notification/edit/';

export const popupNotificationExportBackendPath = '/backend/notification/popup_notification/export/'


// WEBPACK FOOTER //
// ./src/routes/notification/urls.js